<header class="promo-page-header">
  <div class="container">
    <div class="promo-page-header-wrapper">
      <a routerLink="/" class="promo-page-header-logo"></a>
    </div>
  </div>
</header>
<main class="promo-page-main">
  <section class="promo-page-image-section section">
    <div class="container promo-page-image-section-container">
      <picture class="promo-page-image">
        <img [src]="src" [srcset]="srcSet" [alt]="alt" />
      </picture>
    </div>
  </section>
  <section class="promo-page-main-section section">
    <div class="promo-page-main-container container">
      <button box-button theme="primary" class="promo-page-main-button" routerLink="/home">
        {{ ctaText | translate }}
      </button>
      <div class="promo-page-main-text-container">
        <h1 class="promo-page-main-header">{{ pageTitle | translate }}</h1>
        <h2 *ngFor="let text of texts" [innerHTML]="text | translate | safeHtml" class="promo-page-main-text"></h2>
      </div>
    </div>
  </section>
</main>
<box-footer></box-footer>
